module.exports = "/packs/as_mv_conmany_blur-b26d2dc6a1d001aba433391f9efe1d40.jpg";